import http from '../services/http';
import { typeAs } from '../services/utils';

export default {
  namespaced: true,

  state: {
    csr: null,
    projectDetail: null,
    tags: null,
  },

  mutations: {
    INIT_CSR(state) {
      state.csr = {
        title: '',
        background: '',
        call_to_action: '',
        url: '',
        tabs: [],
        projects: [],
        video_rotates: [],
      };
    },
    CLEAR_CSR(state) {
      state.csr = null;
      state.projectDetail = null;
    },
    SET_CSR(state, data) {
      state.csr = data;
    },
    INIT_PROJECT_DETAIL(state, detail) {
      state.projectDetail = detail;
    },
    SET_PROJECT_DETAIL(state, detail) {
      if (!state.csr.projects) {
        state.csr.projects = [];
      }

      if (detail.id) {
        const index = state.csr.projects.map((i) => i.id).indexOf(detail.id);
        state.csr.projects[index] = detail;
      } else {
        state.csr.projects.push(detail);
      }
    },
    SET_TABS(state, detail) {
      state.tabs = detail;
    },
  },

  actions: {
    init({ commit }) {
      commit('INIT_CSR');
    },

    clear({ commit }) {
      commit('CLEAR_CSR');
    },

    setCsr({ commit }, data) {
      commit('SET_CSR', data);
    },

    initProjectDetail({ commit }, detail) {
      commit('INIT_PROJECT_DETAIL', detail);
    },

    setProjectDetail({ commit }, detail) {
      commit('SET_PROJECT_DETAIL', detail);
    },

    find({ commit }) {
      return http('/csr')
        .then((response) => response.body)
        .then(typeAs('Csr'))
        .then((response) => {
          commit('SET_CSR', response);
          return response;
        });
    },

    getTabs({ commit }) {
      return http('/csr/tabs')
        .then((response) => response.body)
        .then(typeAs('Csr'))
        .then((response) => {
          commit('SET_TABS', response);
          return response;
        });
    },

    deleteProject(_, id) {
      const request = http(`/csr/projects/${id}`, { method: 'DELETE' });

      return request.then((response) => response.body);
    },

    save(_, data) {
      const request = http('/csr', { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    saveTabs(_, data) {
      const request = http('/csr/tabs', { method: 'POST', data });

      return request.then((response) => response.body);
    },

    saveProject(_, data) {
      const request = http('/csr/projects', { method: 'POST', data });

      return request.then((response) => response.body);
    },
  },
};
